const faqItems = document.querySelectorAll('.faq__item');
let activeItem = faqItems[0];

faqItems.forEach(item => {
  const header = item.querySelector('.faq__item-header');

  if (item === activeItem) {
    item.classList.add('open');
  }

  header.addEventListener('click', () => {
    if (activeItem && activeItem !== item) {
      activeItem.classList.remove('open');
    }

    item.classList.toggle('open');
    activeItem = item;
  });
});